module.exports = __webpack_public_path__ + "static/media/Spotify-Black-Logo.wine.d72f6cea.svg";